module.exports = __webpack_public_path__ + "img/logo-company-3.08fb6edb.png";